import axios from 'axios'
import { message } from 'ant-design-vue'
import router from '@/router'
import i18n from '../lang'

const websocketUrl = 'wss://ygk.deman.cn:9006/ws/device'

const service = axios.create({
  // baseURL: 'https://ygk.deman.cn/api',
  // baseURL: 'http://10.55.50.82',
  // baseURL: 'http://10.55.50.85:10000/api/',
  // baseURL: 'http://10.55.50.87:10000/api/',
  baseURL: 'https://ygk.deman.cn/api/v2',
  timeout: 600000,
  withCredentials: false
})

let token
let rToken
let start

const timer = setInterval(refreshToken, 3600000)

function setTokenToHeader (requestConfig) {
  token = JSON.parse(localStorage.getItem('token'))
  if (token) {
    requestConfig.headers.Authorization = `Bearer ${token}`
  }
}

export async function refreshToken(path) {
  rToken = JSON.parse(localStorage.getItem('rToken'))
  if (!rToken) {
    clearInterval(timer)
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('rToken')
    router.replace('/login')
    const lang = localStorage.getItem('lang')
    const m = lang === 'en' ? 'Please login' : '请登录'
    if (localStorage.getItem('logout') === '1') {
      localStorage.removeItem('logout')
      return
    }
    message.warn(m)
    return
  }
  try {
    const { data: { data } } = await axios({
      url: `https://ygk.deman.cn/api/v2/auth/accessToken?refreshToken=${rToken}`,
      // url: `http://10.55.50.85:10000/api/auth/accessToken?refreshToken=${rToken}`,
      // url: `http://10.55.50.87:10000/api/auth/accessToken?refreshToken=${rToken}`,
      method: 'GET'
    })
    if (data) {
      localStorage.setItem('token', JSON.stringify(data))
      token = data
      start = +new Date()
      localStorage.setItem('start', start)
      if (path) {
        router.push(path)
      }
    } else {
      clearInterval(timer)
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('rToken')
      router.replace('/login')
      const lang = localStorage.getItem('lang')
      const m = lang === 'en' ? 'Please login' : '请登录'
      message.warn(m)
    }
  } catch {
    clearInterval(timer)
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('rToken')
    router.replace('/login')
    const lang = localStorage.getItem('lang')
    const m = lang === 'en' ? 'Please login' : '请登录'
    message.warn(m)
  }
}

service.interceptors.request.use(async requestConfig => {
  if(requestConfig.url !== 'auth/login' && requestConfig.url !== 'auth/requiredCaptcha') {
    start = localStorage.getItem('start')
    if (!start) {
      await refreshToken()
    } else {
      const end = +new Date()
      if (end - start >= 7000000) {
        await refreshToken()
      }
    }
  }
  setTokenToHeader(requestConfig)

  return requestConfig
},
error => {
  return Promise.reject(error)
})

service.interceptors.response.use(async response => {
  const { data, config } = response
  const { code } = data

  if (["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", 'text/xml', 'application/vnd.ms-excel;charset=utf-8', 'application/vnd.ms-excel'].includes(response.data.type)) {
    return Promise.resolve(response)
  }
  if (code === 0 || config.url === '/screen') {
    if (config.url.startsWith('/customer_profile')) {
      const { data: customerData } = data
      return Promise.resolve(customerData)
    } else {
      return Promise.resolve(data)
    }
  } else if (code === 4001) {
    const lang = localStorage.getItem('lang')
    const m = lang === 'en' ? 'No Permission' : '无操作权限'
    message.warn(m)
  } else if (code === 4002 || code === 4003) {
    refreshToken()
    const lang = localStorage.getItem('lang')
    const m = lang === 'en' ? 'Request failed, please try again later' : '请求失败，请稍后再试'
    message.warn(m)
  } else if (code === 5000 && config.url === '/device/unRegMachine/info') {
    message.warn(i18n.t('messages.noDevice'))
  } else {
    const lang = localStorage.getItem('lang')
    const m = lang === 'en' ? 'Request failed' : '请求失败'
    message.warn(data.message || m)
    return Promise.reject(data)
  }
}, async error => {
  if (error?.response?.data?.code === 4002 || error?.response?.data?.code === 4003) {
    refreshToken()
    const lang = localStorage.getItem('lang')
    error.message = lang === 'en' ? 'Request failed, please try again later' : '请求失败，请稍后再试'
  }
  if (error.config.url === "/device/unRegMachine/info") {
    error.message = i18n.t('无相关设备信息')
  }
  if (error?.message.startsWith('timeout')) {
    const lang = localStorage.getItem('lang')
    error.message = lang === 'en' ? 'request timeout' : '请求超时'
    const m = lang === 'en' ? 'Request failed' : '请求失败'
    message.warn(error?.message || m, 5)
  } else {
    const lang = localStorage.getItem('lang')
    const m = lang === 'en' ? 'Request failed' : '请求失败'
    message.warn(error?.message || m)
  }
  return Promise.reject(error)
})

export default service

export {
  websocketUrl
}
